<template>
    <div class="d-none d-md-block">
        <div class="row pb-4">
            <div class="col-12 col-lg-10">
                <p v-html="tabContent.tabDescription"></p>
            </div>
        </div>

        <div
            v-for="(members, index) in tabContent.memberSubSection"
            :key="'members-' + index + '-' + indexMatrix"
            class="row row-members"
        >
            <div class="col-12 col-lg-4 col-xl-3 col-xxl-2 mb-4 mb-lg-0">
                <h5 class="text-weight-regular">{{members.section.membersTitle}}</h5>
            </div>

            <div class="col-12 col-lg-8 col-xl-9 col-xxl-10">
                <div class="row">
                    <div
                        v-for="(member, index) in members.section.theMembers"
                        :key="'member-' + index + '-' + indexMatrix"
                        class="col-12 col-md-4 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                    >

                    <div
                        class="personnel-member-card"
                        :class="member.member.personnelPhone !== null ||  member.member.personnelEmail !== null ? 'click-effect' : ''"
                    >

                        <div v-if="globalsIsLoaded" class="member-card-header">

                            <AssetLoader
                                v-if="member.member.imgSecondary.imageID"
                                :asset="{ asset: member.member.imgSecondary.imageID }"
                                transform="?mode=crop&width=800&height=500"
                                class="member-img-secondary"
                            />

                            <img
                                v-if="member.member.img.url !== ''"
                                :src="member.member.img.url"
                                class="member-img"
                                :alt="member.member.img.title"
                            />
                            <AssetLoader
                                v-else
                                :asset="{ asset: getRandomElementID() }"
                                transform="?mode=crop&width=800&height=500"
                            />

                            <div class="header-overlay">
                                <p v-if="member.member.personnelPhone !== null" class="mb-0">{{member.member.personnelPhone + ' #' + member.member.personnelPhoneExtension}}</p>
                                <p v-if="member.member.personnelEmail !== null" class="mb-0"><a :href="'mailto:' + member.member.personnelEmail">{{member.member.personnelEmail}}</a></p>
                            </div>

                            <div class="header-hover"></div>

                        </div>

                        <div class="member-card-body">
                            <p class="name text-weight-semibold mb-2">{{member.member.membersTitle}}</p>
                            <p class="text-legal mb-0">{{member.member.personnelOccupation}}</p>
                        </div>

                    </div>
                    </div>
                </div>
            </div>
            <div class="col-separator col-12">
                <div class="sep-hor-black"></div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'PersonnelTabContent',
    components: {
        AssetLoader,
    },
    props: {
        tabContent: {
            type: Object,
            required: true,
        },
        indexMatrix:{
            type: Number,
            required: false,
        },
    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        getRandomElementID() {

            if(this.globalsIsLoaded){
                return this.globals.inisGlobalElement.inisDefaultImage.images[Math.floor(Math.random()*this.globals.inisGlobalElement.inisDefaultImage.images.length)].img.imageID;
            }


        },
    },

}
</script>
